import { useMutation, useQueryClient } from 'react-query';
import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import { PartyType, Party } from '@parties/src/types';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { getUsePartiesQKey } from '@parties/src/features/overview/api/getParties';
import { getUsePartyQKey } from '@parties/src/features/detail/api/getParty';
import { ErrorResponse, StatusResponse } from '../../../../types/API';

interface PostPartyParams {
  sessionId: string;
  type: PartyType;
  payload: Partial<Party> & { id: string };
}

export const postAnvaParty = async ({
  sessionId,
  type,
  payload,
}: PostPartyParams) => {
  const path = `v1/api/anvaflows/${sessionId}/anva-party`;
  const { data, isError } = await wgApi.post<StatusResponse>(path, {
    ...payload,
    type,
  });
  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));
  return data;
};

export const usePostAnvaParty = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation(postAnvaParty, {
    onError: () => {
      cogoToast.error(t('PORTFOLIO_PARTY-CREATION_TOAST_FAILURE'), {
        hideAfter: 5,
      });
    },
    onSettled: (data, _, context) => {
      const queryKey = getUsePartiesQKey();
      queryClient.invalidateQueries(queryKey);
      if (context.payload.id) {
        const queryKeyParty = getUsePartyQKey(context.payload.id);
        queryClient.invalidateQueries(queryKeyParty);
      }
    },
  });
};
